import axios from 'axios';

const submissionURL = process.env.REACT_APP_SAGE_URL ?? '';
const authToken = process.env.REACT_APP_SAGE_AUTHORIZATION_TOKEN ?? ''


type Params = {
  clientId: string;
  answers: any;
};

export const submitRiskAssessment = async ({ answers, clientId }: Params) => {
  const payload = {
    clientId,
    answers
  };
  let res = await axios.post(submissionURL, payload, {
    headers: {
      authentication: authToken
    }
  });
  return res.data;
};